import { createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "App" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NDialogProvider = _resolveComponent("NDialogProvider")!
  const _component_NNotificationProvider = _resolveComponent("NNotificationProvider")!
  const _component_NMessageProvider = _resolveComponent("NMessageProvider")!
  const _component_NLoadingBarProvider = _resolveComponent("NLoadingBarProvider")!

  return (_openBlock(), _createBlock($setup["NConfigProvider"], { "theme-overrides": $setup.themeOverrides }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_NLoadingBarProvider, null, {
          default: _withCtx(() => [
            _createVNode(_component_NMessageProvider, null, {
              default: _withCtx(() => [
                _createVNode(_component_NNotificationProvider, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_NDialogProvider, null, {
                      default: _withCtx(() => [
                        _createVNode($setup["BroadcastWrapper"], null, {
                          default: _withCtx(() => [
                            _createVNode($setup["AppInner"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}